export default class Organization {

  uuid: string
  name: string
  contacted: number
  uncontacted: number
  total: number

}